module.exports = __webpack_public_path__ + "assets/img/home-customer-choice.d0cc20b8.png";